'use client';

import { useMicrocopy } from '@contexts/MicrocopyContext';
import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { useContext } from 'react';
import { SearchSelect } from './SearchSelect';
import { useResults } from './hooks/useResults';
import { SORT_CRITERIA, useSortController } from './hooks/useSortingController';

export const Sorting = ({ context }: { context: AtomicContext }) => {
  const { searchEngine, coveoContext } = useContext(context);
  const { currentSortValue, setSort } = useSortController(
    searchEngine,
    coveoContext
  );
  const { results: resultState } = useResults(searchEngine);
  const shouldDisplay = resultState?.results && resultState.results.length > 0;

  const { searchLabelsMicrocopy } = useMicrocopy<{
    searchLabelsMicrocopy: MicrocopyFragment[];
  }>();
  const sortByLabel =
    searchLabelsMicrocopy.find(
      (microcopyFragment) => microcopyFragment.key === 'search.sort-by'
    )?.value ?? 'Sort by';
  const getSortOptionLabelByValue = (value: string) =>
    searchLabelsMicrocopy.find(
      (microcopyFragment) => microcopyFragment.key === `search.${value}`
    )?.value ?? value;

  if (!shouldDisplay) {
    return null;
  }

  return (
    <SearchSelect
      label={sortByLabel}
      testId="search-sort-by-select"
      currentValue={currentSortValue}
      handleChange={(value) => setSort(value)}
    >
      {SORT_CRITERIA.map(({ value }) => (
        <option key={value} value={value}>
          {getSortOptionLabelByValue(value)}
        </option>
      ))}
    </SearchSelect>
  );
};
